import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FooterPageComponent } from '../pages/cms/footer/footer-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class FooterFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<FooterPageComponent>
{
  canDeactivate(
    component: FooterPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(component.footerForm),
      nextState.url,
      () => component.resetFormChanges,
      () => component.save()
    );
  }
}
